import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { throttle } from 'lodash'

const navbarHeight = 80
const Sidebar = ({ courses, titles, selectedCourse, handleCourseClick }) => {
  const sidebarRef = useRef(null)
  const [sticky, setSticky] = useState(false)

  useEffect(() => {
    const handleScroll = throttle(() => {
      if (sidebarRef.current) {
        const sidebarRect = sidebarRef.current.getBoundingClientRect()
        const sidebarTop = sidebarRect.top
        setSticky(sidebarTop <= navbarHeight + 10)
      }
    }, 500) // 500ms throttle time

    window.addEventListener('scroll', handleScroll)
    window.addEventListener('load', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('load', handleScroll)
    }
  }, [])

  useEffect(() => {
    if (sidebarRef.current && selectedCourse) {
      const selectedOption = sidebarRef.current.querySelector('.selected')
      if (selectedOption) {
        selectedOption.scrollIntoView({
          behavior: 'instant',
          block: 'nearest',
          inline: 'center',
        })
      }
    }
  }, [selectedCourse])

  return (
    <div className={`sidebar${sticky ? ' sticky' : ''}`} ref={sidebarRef}>
      <div className="is-2-desktop">
        <ul>
          {courses &&
            courses.map((course, index) => (
              <li
                key={titles[index]}
                onClick={() => handleCourseClick(course)}
                className={course === selectedCourse ? 'selected' : null}
              >
                <span>{titles[index]}</span>
                <span className="underline"></span>
              </li>
            ))}
        </ul>
      </div>
    </div>
  )
}

Sidebar.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
    })
  ),
  selectedCourse: PropTypes.shape({
    title: PropTypes.string,
  }),
  handleCourseClick: PropTypes.func.isRequired,
}

export default Sidebar
